var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.395,
    height: 178.282,
    viewBox: "0 0 153.395 178.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Notification",
    "data-name": "Iconly Two-tone Notification",
    transform: "translate(-945.753 -537.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification-8",
    transform: "translate(945.753 537.097)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1-112",
    "data-name": "Stroke 1-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_321",
    "data-name": "Caminho 321",
    d: "M1022.438,680.964c-38.778,0-73.816-2.737-76.685-35.768-.025-13.676,4.146-20.617,7.829-26.745,3.723-6.187,7.231-12.033,7.231-25.833,0-26.811,24.763-55.521,61.625-55.521s61.625,28.719,61.625,55.53c0,13.791,3.508,19.646,7.231,25.84,3.683,6.12,7.854,13.07,7.854,26.2C1096.254,678.227,1061.216,680.964,1022.438,680.964Zm0-131.427c-28.984,0-49.186,22.707-49.186,43.082,0,17.25-4.785,25.2-9.006,32.235-3.4,5.656-6.079,10.117-6.079,19.812,1.385,15.649,11.709,23.859,64.271,23.859,52.27,0,62.918-8.575,64.295-24.4-.024-9.139-2.7-13.608-6.1-19.256-4.229-7.033-9.014-14.994-9.014-32.243C1071.624,572.243,1051.422,549.537,1022.438,549.537Z",
    transform: "translate(-945.753 -537.097)",
    fill: "#d3ff9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3-89",
    "data-name": "Stroke 3-89",
    transform: "translate(49.888 156.382)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_322",
    "data-name": "Caminho 322",
    d: "M978.151,577.855a32.4,32.4,0,0,1-20.725-7.472,33.664,33.664,0,0,1-4.213-4.213,6.223,6.223,0,0,1,9.545-7.986,20.862,20.862,0,0,0,2.637,2.637,20.05,20.05,0,0,0,28.188-2.621,6.222,6.222,0,1,1,9.571,7.953A32.414,32.414,0,0,1,978.151,577.855Z",
    transform: "translate(-951.769 -555.954)",
    fill: "#d3ff9a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.4c4c2177ebca149cecf21589cd2bd54d.svg";
export { ForwardRef as ReactComponent };